/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { emit } from "@nextcloud/event-bus";
var PostMessageService = /** @class */ function () {
    function PostMessageService(targets) {
        var _this = this;
        this.postMessageHandlers = [];
        this.targets = targets;
        window.addEventListener('message', function (event) {
            _this.handlePostMessage(event.data);
        }, false);
    }
    PostMessageService.prototype.sendPostMessage = function (target, message, targetOrigin) {
        if (targetOrigin === void 0) {
            targetOrigin = '*';
        }
        var targetElement;
        if (typeof this.targets[target] === 'function') {
            targetElement = this.targets[target]();
        }
        else {
            targetElement = this.targets[target];
        }
        targetElement.postMessage(message, targetOrigin);
        console.debug('PostMessageService.sendPostMessage', target, message);
    };
    PostMessageService.prototype.sendWOPIPostMessage = function (target, msgId, values) {
        if (values === void 0) {
            values = {};
        }
        var msg = {
            MessageId: msgId,
            SendTime: Date.now(),
            Values: values
        };
        this.sendPostMessage(target, JSON.stringify(msg));
    };
    PostMessageService.parsePostMessage = function (data) {
        var msgId, args, deprecated;
        try {
            var msg = JSON.parse(data);
            msgId = msg.MessageId;
            args = msg.Values;
            deprecated = !!msg.Values.Deprecated;
        }
        catch (exc) {
            msgId = data;
        }
        return {
            msgId: msgId,
            args: args,
            deprecated: deprecated
        };
    };
    PostMessageService.prototype.registerPostMessageHandler = function (callback) {
        this.postMessageHandlers.push(callback);
    };
    PostMessageService.prototype.unregisterPostMessageHandler = function (callback) {
        var handlerIndex = this.postMessageHandlers.findIndex(function (cb) {
            return cb === callback;
        });
        delete this.postMessageHandlers[handlerIndex];
    };
    PostMessageService.prototype.handlePostMessage = function (data) {
        var parsed = PostMessageService.parsePostMessage(data);
        if (typeof parsed === 'undefined' || parsed === null) {
            return;
        }
        try {
            var wopiPostMessage = JSON.parse(data);
            if (typeof wopiPostMessage === 'object' && wopiPostMessage !== null) {
                emit('richdocuments:wopi-post', wopiPostMessage);
            }
        }
        catch (e) { }
        this.postMessageHandlers.forEach(function (fn) {
            if (parsed.deprecated) {
                console.debug('PostMessageService.handlePostMessage', 'Ignoring deprecated post message', parsed.msgId);
                return;
            }
            try {
                fn({
                    data: data,
                    parsed: parsed
                });
            }
            catch (e) {
                console.error('Error during post message handler', parsed, e);
            }
        });
    };
    return PostMessageService;
}();
export default PostMessageService;
